import { Stack, Divider } from '@kinesis/bungle';
import { PathwayScenarioOutput } from '@/types';
import { Layout } from '@/components/layout';
import { DownloadLink } from './download-link';
import { BudgetIndicators } from './budget-indicators';
import { AnnualEmissions } from './annual-emissions';
import { EmissionsReductions } from './emissions-reductions';

const PathwayScenarioOutputs = (props: PathwayScenarioOutputsProps) => {
  const { simulation, onDownload, downloading } = props;
  return (
    <Layout>
      <Stack space='medium'>
        <Stack space='large'>
          <BudgetIndicators budget={simulation.budget} />
          <AnnualEmissions emissions={simulation.emissions} />
          <EmissionsReductions reductions={simulation.reductions} />
          <Divider />
        </Stack>
        <DownloadLink onDownload={onDownload} downloading={downloading} />
      </Stack>
    </Layout>
  );
};

export type PathwayScenarioOutputsProps = {
  simulation: PathwayScenarioOutput;
  onDownload?: () => void;
  // The download is in flight — the link's spinner shows until it settles.
  downloading?: boolean;
};

export { PathwayScenarioOutputs };
